module.exports = __webpack_public_path__ + "img/kushenta-1.93a82d2c.jpg";